import { createFeatureSelector, createSelector } from '@ngrx/store';
import { categoryFeatureKey, CategoryState } from './category-reducer';

export const getFilterCategoryState = createFeatureSelector<CategoryState>(categoryFeatureKey);

export const getCategoryState = createSelector(getFilterCategoryState, (state: CategoryState) => state);
